<template>
  <component
    :is="componentIs"
    :visible.sync="visible"
    :title="roomId ? $t('pc_biz_edit_live' /* 编辑直播 */):$t('pc_biz_add_live' /* 添加直播 */)"
    :destroy-on-close="true"
    size="720px"
    @close="close"
  >
    <LiveForm
      :fields="fieldsAll"
      ref="liveForm"
      :roomId="roomId"
      :liveRoomInfo="liveRoomInfo"
    />
    <div
      class="tlive-create__more--config"
      @click="setMoreConfig"
      v-if="moreFields.length && !showMore"
    >
      {{ $t('pc_tlive_moreSettings' /* 更多设置 */) }}
      <em class="yxt-icon-arrow-down"></em>
    </div>
    <div slot="footer" class="tlive-create-footer">
      <yxt-button plain @click="()=>close()" v-if="!btnOperationHidden.includes('cancel')">{{
        $t('pc_biz_live_cancel' /* 取消 */)
      }}</yxt-button>
      <yxt-button
        type="second"
        @click="beforeCreate()"
        :loading="createLoading"
        v-if="!btnOperationHidden.includes('save')"
        >{{
          roomId
            ? $t('pc_biz_live_save' /* 保存 */)
            : $t('pc_biz_live_create' /* 创建 */)
        }}</yxt-button
      >
      <yxt-button
        type="primary"
        @click="beforeCreate('into')"
        :loading="createIntoLoading"
        v-if="!btnOperationHidden.includes('saveInto')"
        >{{
          roomId
            ? $t('pc_biz_live_saveIntoManage' /* 保存并进入管理后台 */)
            : $t('pc_biz_live_crateIntoManage' /* 创建并进入管理后台 */)
        }}</yxt-button
      >
    </div>
  </component>
</template>

<script>
import { Drawer } from 'yxt-pc';
import LiveForm from './LiveForm.vue';
import moment from 'moment';
import { createTLiveRoom, updateTliveRoom } from './services/http';

const showType = {
  DRAWER: 'drawer',
  PAGE: 'page'
};
export default {
  name: 'YxtbizCreateLive',
  provide() {
    return {
      isGroupOrg: this.isGroupOrg
    };
  },
  props: {
    fields: {
      type: Array,
      default: () => ['recorded', 'remark']
    },
    moreFields: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    showType: {
      type: String,
      default: 'drawer'
    },
    roomId: {
      type: Number,
      default: 0
    },
    jumpManageFromNewPage: {
      type: Boolean,
      default: false
    },
    btnOperationHidden: {
      type: Array,
      default: () => []
    },
    errorCode: {
      type: Array,
      default: [270000, 270005]
    },
    masterId: {
      type: Number,
      default: 0
    },
    masterType: {
      type: Number,
      default: 0
    },
    liveType: {
      type: String,
      default: ''
    }

  },
  components: {
    YxtDrawer: Drawer,
    LiveForm
  },
  computed: {
    componentIs() {
      return this.showType === showType.DRAWER ? 'YxtDrawer' : 'div';
    },
    isGroupOrg() {
      return this.liveType === 'grouporg';
    }
  },
  data() {
    return {
      createLoading: false,
      createIntoLoading: false,
      liveRoomInfo: {},
      fieldsAll: [],
      showMore: false
    };
  },
  watch: {
    fields: {
      handler() {
        this.fieldsAll = this.fields;
      },
      immediate: true
    }
  },
  methods: {
    close(isSuccess, res) {
      this.$emit('update:visible', false);
      isSuccess ? this.$emit('onSuccess', res) : this.$emit('onCancel');
    },
    setMoreConfig() {
      this.fieldsAll = [...this.fieldsAll, ...this.moreFields];
      this.showMore = true;
    },
    beforeCreate(isInto) {
      const formModel = this.$refs.liveForm.formModel;
      this.onCheckFormItem(formModel, isInto);

    },
    onCheckFormItem(formModel, isInto) {
      if (this.fields.includes('remark')) {
        const instance = this.$refs.liveForm.getInstance('LiveRemark');
        if (instance.getInnerText().length > 5000) {
          this.$message({
            duration: 2000,
            message: this.$t('pc_biz_tooLong' /* 详情内容过长 */),
            type: 'error'
          });
          this.createLoading = this.createIntoLoading = false;
          return ;
        }
      }
      const {inside, outside, students} = formModel;
      if (this.fields.includes('inside')) {
        if (!(inside.inside || outside || students.length)) {
          this.$message({
            showClose: false,
            // 请选择允许观看的人员范围
            message: this.$t(
              'pc_biz_pleaseChoseWatchType' /* 请选择允许观看的人员范围！ */,
            ),
            type: 'error'
          });
          return;
        }
      }
      this.$refs.liveForm.validate(valid => {
        if (valid) {
          this.onCreated(formModel, isInto);
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName('is-error');
            isError[0].scrollIntoView({
              // 滚动到指定节点
              // 值有start,center,end，nearest，当前显示在视图区域中间
              block: 'center',
              // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              behavior: 'smooth'
            });
          });
          return;
        }
      });
    },
    jumpToManage(id) {
      const path = this.isGroupOrg ? 'orgdetail' : 'detail';
      const href = window.location.origin + `/tlive/#/${path}?id=${id}`;
      if (this.jumpManageFromNewPage) {
        window.open(href, '_blank');
        return;
      }
      window.location.replace(
        href
      );
    },
    async onCreated(formModel, isInto) {
      if (this.createIntoLoading || this.createLoading) return;
      if (isInto) {
        this.createIntoLoading = true;
      } else {
        this.createLoading = true;
      }
      const hasRemark = this.fields.includes('remark');
      try {
        const instance = hasRemark && this.$refs.liveForm.getInstance('LiveRemark');
        const payload = {
          ...formModel,
          remark: instance ? instance.getInnerHtml() : '',
          roomName: formModel.roomName.trim(),
          mobile: formModel.type === 'pc' ? '0' : '1',
          teacherIdLst: formModel.teacher.map(item => item.id),
          studentIdLst: formModel.students.map(item => item.id),
          beginTime: moment(formModel.beginTime).format('YYYY-MM-DD HH:mm:ss'),
          duration: formModel.duration * 60,
          inside: formModel.inside.inside,
          publishType: this.isGroupOrg ? 0 : formModel.inside.publishType,
          masterId: this.masterId || '',
          masterType: this.masterType || '',
          selectOrgIds: formModel.selectOrgIds.map(item=>item.orgId),
          orgType: this.isGroupOrg ? 1 : 0
        };
        const res = this.roomId
          ? await updateTliveRoom(this.roomId, payload)
          : await createTLiveRoom(payload);

        this.$message({
          duration: 1000,
          message: this.$t('pc_biz_createdSuccessfully' /* 创建成功 */),
          type: 'success',
          onClose: () => {
            localStorage.setItem(`firstEnter-${this.roomId}`, true);
            isInto && this.jumpToManage(res.id);
            this.close('success', res);
            this.createLoading = this.createIntoLoading = false;
          }
        });
      } catch (error) {
        this.createLoading = this.createIntoLoading = false;
        const createCodeList = this.errorCode;
        if (createCodeList.includes(error.error.code)) {
          this.$confirm(
            error.error.message,
            this.$t('pc_biz_udp_lbl_closeTitle' /* 提示 */),
            {
              type: 'warning'
            }
          );
          return;
        }
        this.$emit('onFailed', error);
      }
    }
  }
};
</script>
